// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type ClientMembershipsQueryVariables = Types.Exact<{
  clientId: Types.Scalars["bigint"]["input"];
}>;

export type ClientMembershipsQuery = {
  __typename?: "query_root";
  clientMembership: Array<{
    __typename?: "ClientMembership";
    id: string;
    status: string;
    startedAt?: string | null;
    cancelAt?: string | null;
    canceledAt?: string | null;
    membership: {
      __typename?: "Membership";
      id: string;
      title: string;
      description: string;
      billingInterval: string;
      pricePerBillingPeriod?: string | null;
      billingIntervalCount: number;
      cancellationFeeValue?: string | null;
      membershipPerks: Array<{
        __typename?: "MembershipPerk";
        id: string;
        dollarCreditAmount?: string | null;
        perkType: string;
        discount?: {
          __typename?: "discount";
          id: string;
          name: string;
          discountType: string;
          value: string;
          quantityLimit?: number | null;
          isMembership: boolean;
          discountServiceProducts: Array<{
            __typename?: "discountServiceProducts";
            id: string;
            medspaServiceProduct: {
              __typename?: "MedspaServiceProduct";
              id: string;
              serviceProduct: {
                __typename?: "ServiceProduct";
                id: string;
                name: string;
              };
            };
          }>;
          discountServiceMenuItems: Array<{
            __typename?: "discountServiceMenuItems";
            id: string;
            serviceMenuItem: {
              __typename?: "MedspaServiceMenuItem";
              id: string;
              name: string;
            };
          }>;
          discountRetailProducts: Array<{
            __typename?: "discountRetailProducts";
            id: string;
            product: { __typename?: "product"; id: string; name: string };
          }>;
        } | null;
      }>;
    };
  }>;
};

export const ClientMembershipsDocument = gql`
  query ClientMemberships($clientId: bigint!) {
    clientMembership(
      where: { clientId: { _eq: $clientId } }
      orderBy: { membership: { title: ASC } }
    ) {
      id
      status
      startedAt
      cancelAt
      canceledAt
      membership {
        id
        title
        description
        billingInterval
        pricePerBillingPeriod
        billingIntervalCount
        cancellationFeeValue
        membershipPerks(where: { deletedAt: { _isNull: true } }) {
          id
          dollarCreditAmount
          perkType
          discount {
            id
            name
            discountType
            value
            quantityLimit
            isMembership
            discountServiceProducts(
              where: { medspaServiceProduct: { isEnabled: { _eq: true } } }
            ) {
              id
              medspaServiceProduct {
                id
                serviceProduct {
                  id
                  name
                }
              }
            }
            discountServiceMenuItems(
              where: { serviceMenuItem: { deletedAt: { _isNull: true } } }
            ) {
              id
              serviceMenuItem {
                id
                name
              }
            }
            discountRetailProducts(
              where: { product: { deleted: { _eq: false } } }
            ) {
              id
              product {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useClientMembershipsQuery__
 *
 * To run a query within a React component, call `useClientMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMembershipsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientMembershipsQuery,
    ClientMembershipsQueryVariables
  > &
    (
      | { variables: ClientMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientMembershipsQuery,
    ClientMembershipsQueryVariables
  >(ClientMembershipsDocument, options);
}
export function useClientMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientMembershipsQuery,
    ClientMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientMembershipsQuery,
    ClientMembershipsQueryVariables
  >(ClientMembershipsDocument, options);
}
export function useClientMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ClientMembershipsQuery,
        ClientMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClientMembershipsQuery,
    ClientMembershipsQueryVariables
  >(ClientMembershipsDocument, options);
}
export type ClientMembershipsQueryHookResult = ReturnType<
  typeof useClientMembershipsQuery
>;
export type ClientMembershipsLazyQueryHookResult = ReturnType<
  typeof useClientMembershipsLazyQuery
>;
export type ClientMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useClientMembershipsSuspenseQuery
>;
export type ClientMembershipsQueryResult = Apollo.QueryResult<
  ClientMembershipsQuery,
  ClientMembershipsQueryVariables
>;
